<app-discussion-container-bsr></app-discussion-container-bsr>
